var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconApartmentLinkDeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.88867 9.55601L9.55502 4.88965",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44434 2.55618L6.80442 2.13932C7.16553 1.77812 7.59425 1.49159 8.06611 1.2961C8.53796 1.10062 9.04371 1 9.55446 1C10.0652 1 10.5709 1.10062 11.0428 1.2961C11.5147 1.49159 11.9434 1.77812 12.3045 2.13932C12.6663 2.50011 12.9533 2.92876 13.1492 3.40069C13.345 3.87263 13.4457 4.37857 13.4457 4.88952C13.4456 5.40047 13.3447 5.90638 13.1487 6.37826C12.9528 6.85014 12.6656 7.27871 12.3037 7.6394",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69087 12.3042C6.95281 13.0335 5.95704 13.4425 4.91945 13.4425C3.88187 13.4425 2.8861 13.0335 2.14803 12.3042C1.78433 11.9446 1.49559 11.5164 1.29853 11.0444C1.10147 10.5724 1 10.066 1 9.55456C1 9.04309 1.10147 8.5367 1.29853 8.06472C1.49559 7.59273 1.78433 7.16453 2.14803 6.80491L2.55556 6.44482",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.333 12.667H14.9994",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.666 10.334V15.0003",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApartmentLinkDeal);
export default __webpack_public_path__ + "static/media/icon_apartment_link_deal.af8fc503c805647bf195e4902df7376f.svg";
export { ForwardRef as ReactComponent };